import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import TextInput from '../BaseComponents/TextInput';
import ThemeColorPicker from '../BaseComponents/ThemeColorPicker';

const ThemeColorPickerField = (props: WidgetProps) => {
    const { schema, uiSchema, onChange } = props;
    const uiSchemaOptions = uiSchema?.['ui:options'];
    const [formData, setFormData] = useState(props.formData);

    const handleChange = (value: any, id: string) => {
        setFormData({ ...formData, [id]: value });
        onChange({ ...formData, [id]: value });
    };

    const properties = schema.properties && Object.values(schema.properties);
    const propertyKeys = schema.properties && Object.keys(schema.properties);

    return (
        <div className="color-picker">
            <label>{props.schema.title}</label>
            <div className="color-picker-field">
                {properties?.length &&
                    propertyKeys?.length &&
                    properties.map((p: any, i: number) => {
                        const key = propertyKeys[i];
                        return (
                            <>
                                {key === 'key' ? (
                                    <div className={'color-name-input'} key={`${p}-${i}`}>
                                        <TextInput
                                            label={p.title}
                                            placeholder={p.description}
                                            value={formData[key]}
                                            onChange={(e) => handleChange(e.target.value, key)}
                                            labelId={'custom-input-label'}
                                            inputId={'custom-text-input'}
                                            disabled={
                                                (uiSchemaOptions?.isTextInputDisabled as boolean) ||
                                                false
                                            }
                                        />
                                    </div>
                                ) : (
                                    key === 'value' && (
                                        <ThemeColorPicker
                                            label={p.title}
                                            value={formData[key]}
                                            colorKey={formData.key}
                                            uiSchemaOptions={uiSchemaOptions}
                                            onChange={(v) => handleChange(v, key)}
                                        />
                                    )
                                )}
                            </>
                        );
                    })}
            </div>
        </div>
    );
};

export default ThemeColorPickerField;
